module.exports = __webpack_public_path__ + "img/list_img2.52c42d26.png";